export class Group {
    name: string;
    creator: boolean;

    constructor(name: string, creator: boolean = false) {
        this.name = name;
        this.creator = creator;
    }

    static getUniqueGroups(groups: Group[]): Group[] {
        return groups.filter(g => g.name).reduce(
            (arr: Group[], item: Group) => {
                return arr.map(a => a.name.toLowerCase())
                    .includes(item.name.toLowerCase()) ? arr : [...arr, item];
            }, 
            []
        );
    }

    static getUniqueGroupNames(groupNames: string[]): string[] {
        return groupNames.filter(gn => gn).reduce(
            (arr: string[], item: string) => {
                return arr.map(a => a.toLowerCase())
                    .includes(item.toLowerCase()) ? arr : [...arr, item];
            }, 
            []
        );
    } 
}

export default Group;
